<template>
  <div class="crud_module--api_view_details_modal">
    <div class="inner-wrap">
      <div class="action-btn">
        <div class="button">
          <el-button @click="exportExcel(setting.api, setting, getParams(), getExcelFilename())" type="warning" size="mini">
            <fa :icon="['fas','file-export']" style="margin-right:5px;"/>{{ $t("label.export_as_") }}Excel
          </el-button>
        </div>
        <div class="button">
          <el-button @click="refresh" type="primary" size="mini">
            <fa :icon="['fas','redo']" style="margin-right:5px;"/>
          </el-button>
        </div>
      </div>
      <div class="content" v-loading="loading">
        <div class="chart-wrapper" ref="chart" v-loading="!show_chart">
          <div class="loading-dummy" :style="`height:${chart_height}px;`" v-if="!show_chart"></div>
          <LineChart :rows="rows" v-if="rows.length > 0 && show_chart"/>
        </div>
        <div class="detail">
          <div class="item" v-for="(item,j) in setting.extra_fields" :key="j">
          <div class="data">
            <div class="label">{{ tran(namespace, `${typeof item == "object" ? item.key : item}`) }}</div>
            <div class="value">
              <div class="text">
                <div v-if="item.type == 'datetime'">
                  {{ data[item.key] ? $moment(data[item.key]).format("YYYY-MM-DD HH:mm:ss") : "" }}
                </div>
                <div v-else-if="item.type == 's_to_hms'">
                  {{ data[item.key] ? getTime(data[item.key]) : "00:00:00" }}
                </div>
                <div v-else>{{ item.hasOwnProperty("field") ? getValueByField(data, item) : data[item.key] }}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <vxe-table
          ref="table"
          size="mini"
          border
          show-header-overflow
          show-overflow
          highlight-hover-row
          :empty-text="$t('label.no_data_found')"
          :remote-sort="true"
          @sort-change="sortChanged"
          @cell-click="clickedCell"
          :loading="loading"
          :key="new Date().getTime()"
        :data="rows">
          <vxe-table-column
            v-for="(field,index) in setting.fields" :key="field.key"
            :field="field.key"
            :title="field.key"
            :width="field.width"
            :sortable="setting.sort_fields ? setting.sort_fields.includes(field.key) : false"
          >
            <template v-slot:header="{ columnIndex }">
              <div class="header-wrap">
                <div class="name">
                  {{ tran(key, setting.fields[columnIndex].key) }}
                </div>
              </div>
            </template>
            <template v-slot="{ row }">
              <div v-if="field.type == 'boolean'">
                <el-checkbox :checked="row[field.key] == 1"/>
                <div class="block-layer"></div>
              </div>

              <div v-else-if="field.type == 'datetime'">
                {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD HH:mm:ss") : "" }}
              </div>

              <div v-else-if="field.type == 'meter_value'">
                {{ getMeterValue(row, field) }}
              </div>

              <!-- <div v-else-if="field.type == 's_to_hms'">
                {{ row[field.key] ? getTime(row[field.key]) : "" }}
              </div> -->

              <!-- <div class="action" v-else-if="field.type == 'action-btn'">
                <div>
                  <el-button
                    type="info"
                    size="mini"
                    @click="showDetails(option.id ? row[option.id] : row.id)"
                    v-if="option.action.includes('view')"
                  >
                    <fa :icon="['fas', 'list-alt']"/>
                  </el-button>
                </div>
              </div> -->

              <div v-else>{{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] }}</div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="footer">
        <div class="result">
          {{ $tc("label.total_record_desc", 1, { row: rows.length }) }}
        </div>
        <div class="pagination">
          <!-- <div class="page first" @click="changePage(1)" :class="[{ 'current': pagination.current == 1 }]" v-if="Math.ceil(pagination.current/5) > 1">1</div>
          <div class="page" :class="[{ 'current': pagination.current == i }]" v-for="i in generated_pages" :page="i" :key="`p-${i}`" @click="changePage(i)">{{ i }}</div>
          <div class="page last" @click="changePage(pagination.max)" :class="[{ 'current': pagination.current == pagination.max }]" v-if="Math.ceil(pagination.current/5) < Math.ceil(pagination.max/5)">{{ pagination.max }}</div> -->
          <!-- <el-pagination
            background
            @current-change="changePage"
            :current-page.sync="pagination.current"
            :page-size="1"
            layout="jumper, prev, pager, next"
            :total="pagination.max">
          </el-pagination> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/widgets/LineChart";

export default {
  components: {
    LineChart
  },
  props: {
    namespace: String,
    setting: {
      type: Object,
      default() {
        return {};
      }
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  async beforeMount() {
    this.key = this.setting.key;
    this.loading = true;
    this.fetchData();
    this.loading = false;
    this.show_chart = true;
  },
  methods: {
    async refresh() {
      await this.fetchData();
      // this.$refs.chart.reload();
    },
    async fetchData() {
      this.show_chart = false;
      this.chart_height = this.$refs.chart ? this.$refs.chart.clientHeight : 0;
      let params = {};
      params[this.setting.id] = this.data[this.setting.id];
      await this.$axios.get(this.setting.api, {
        params: {
          ...params,
          ...this.setting.params,
          // size: this.pagination.perPage,
          // page: this.pagination.current > 0 ? this.pagination.current - 1 : 0,
        //   sort_by: this.sort.field ? this.sort.field : this.setting?.sort?.field,
        // order: this.sort.order ? this.sort.order : this.setting?.sort?.order,
        },
      }).then(res=>{
        let data = res.data.response.dataset;
        this.rows = data;
        // this.pagination.max = data.totalPages;
        // if(this.pagination.current > this.pagination.max && this.pagination.max > 0) {
        //   this.pagination.current = this.pagination.max;
        //   this.fetchData();
        // }
        // this.pagination.item = data.totalElements;
        this.$refs.table.updateData();
        this.show_chart = true;
      }).catch(err=>err);
    },
    getValue(field) {
      // console.log(field);
      let split = field.value ? field.value.split(".") : field.split(".");
      console.log("split: ",split);
      if(split.length == 1) return this.data[field];
      let value = this.data;
      console.log("value: ",value);
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        value = value[f];
        // console.log(value);
      });
      return value;
    },
    clickedCell({ rowIndex }) {
      this.selected_row = rowIndex;
    },
    getParams() {
      let params = {};
      params[this.setting.id] = this.data[this.setting.id];
      return {
        sort_by: this.sort.field ? this.sort.field : this.setting?.sort?.field,
        order: this.sort.order ? this.sort.order : this.setting?.sort?.order,
        ...params,
        ...this.setting.params,
      }
    },
    fillZero(num) {
      num = Math.abs(num);
      return num < 10 ? `0${num}` : num;
    },
    getTime(sec) {
      // let h = Math.abs(Math.floor(sec/(60*60)));
      let h = Math.floor(sec/(60*60));
      let m = Math.floor(sec/(60)) - h*60;
      let s = sec%60;

      if(sec > 0) {
        return `${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }else {
        return `-${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }
    },
    sortChanged({column, property, order, $event}) {
      console.log("column: ",column);
      console.log("property: ",property);
      console.log("order: ",order);
      console.log("$event: ",$event);
      this.sort.field = property;
      this.sort.order = order;
      this.fetchData();
    },
    getMeterValue(data, field) {
      let json = {};
      try{
        json = JSON.parse(data.request_data);
      }catch{
        return 0.000;
      }
      let obj = json.meterValue[0].sampledValue.find(val=>val.unit==field.unit);
      let value = obj ? obj.value : null;
      if(value == null) return 0.000;
      if(field.key == "energy") {
        return (value/1000).toFixed(3);
      }else {
        return parseFloat(value).toFixed(3);
      }
    },
    changePage(page) {
      this.selected_row = -1;
      this.pagination.current = page;
      this.fetchData();
    },
    getExcelFilename() {
      return `${this.setting.key}_${this.data.cp_id.cp_no}_`;
    }
  },
  data() {
    return {
      key: "",
      loading: false,
      show_chart: false,
      chart_height: 0,
      rows: [],
      selected_row: -1,
      pagination: {
        perPage: 10,
        total: 0,
        current: 1,
        item: 0,
        max: 0
      },
      sort: {
        field: "",
        order: ""
      }
    }
  }
}
</script>

<style lang="scss">
.crud_module--api_view_details_modal{
  // height: 90vh;
  width: 95vw;
  background: white;
  border-radius: 3px;
  overflow: auto;
  .inner-wrap{
    padding: 20px;
    height: 85vh;
    overflow-y: auto;
    .action-btn{
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      .export-btn{
        display: flex;
        justify-content: flex-end;
        
      }
    }
    .content{
      // padding: 20px;
      .detail{
        .item{
          font-size: 12px;
          margin-bottom: 10px;
          .data{
            width: 100%;
            display: flex;
          }
          .label{
            width: 130px;
            min-width: 130px;
            display: flex;
            align-items: center;
          }
          .data{
            .value{
              min-width: 200px;
              width: 100%;
              border: 1px solid gray;
              background-color: #E6E6E6 !important;
              padding: 3px 5px;
            }
          }
        }
      }
      .row{
        display: flex;
        margin-bottom: 10px;
        .item{
          flex-grow: 1;
          display: flex;
          width: 800px;
          font-size: x-small;
          .label{
            width: 100px;
            min-width: 100px;
          }
          .value{
            min-width: 200px;
            width: 100%;
            border: 1px solid gray;
            background-color: #E6E6E6 !important;
            padding: 3px 5px;
            .json{
              .vjs-tree.is-root{
                &,.vjs-key,.vjs-value{
                  font-size: xx-small;
                }
              }
            }
          }
          &:not(:first-child) {
            margin-left: 10px;
          }
        }
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .result{
        font-size: small;
      }
      .pagination{
        display: flex;
        margin-top: 10px;
        justify-content: flex-end;
        .page{
          font-size: x-small;
          cursor: pointer;
          user-select: none;
          width: 25px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #c5e1ff;
          border-color: #c5e1ff;
          color: white;
          &:not(:last-child) {
            margin-right: 10px;
          }
          &.current{
            background-color: #409EFF;
            border-color: #409EFF;
          }
        }
      }
    }
  }
}
</style>